<template>
    <div class="loading-modal" v-if="loading">
        <div class="loading-content">
            <div class="loading-center">
                <div class="loading-spinner"></div>
                <div class="loading-text">{{ loading_text }} .....</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
      loading: Boolean,
      loading_text: null,
    },
};
</script>
<style scoped>
.loading-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}
.loading-content {
    background-color: white;
    padding: 80px 150px;
    border-radius: 5px;
    text-align: center;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
}
.loading-center {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
}
.loading-spinner {
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-top: 4px solid #399A6F;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    animation: spin 1s linear infinite;
}
.loading-text{
    font-size: 1.1rem;
    padding-top: 10px;
    letter-spacing: 0.5px;
}
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>